const numbers = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
const lowerCaseLetters = [...Array(26)].map((__, index) =>
  String.fromCharCode(index + "a".charCodeAt(0))
);
const uppercaseLetters = lowerCaseLetters.map((letter) => letter.toUpperCase());

const allSymbols = [...numbers, ...lowerCaseLetters, ...uppercaseLetters];

function getRandomSample(array) {
  return array[Math.floor(Math.random() * array.length)];
}

export function generatePassword() {
  let arr = [];

  arr.push(getRandomSample(numbers));
  arr.push(getRandomSample(lowerCaseLetters));
  arr.push(getRandomSample(uppercaseLetters));

  while (arr.length < 8) {
    arr.push(getRandomSample(allSymbols));
  }

  return arr.join("");
}

export const passwordSchemaTest = {
  name: "validPassword",
  message:
    "${path} must include one number, one letter, one uppercase letter and be between 6 and 40 characters",
  test: (value) => {
    const hasUpperCase = /[A-Z]/.test(value);
    const hasNumber = /[0-9]/.test(value);
    const hasLowerCase = /[a-z]/.test(value);
    return hasUpperCase && hasNumber && hasLowerCase;
  }
};
